/** 판매·관리 발송 모달에 공통으로 쓰는 택배사. 직접배송은 항상 맨 아래. */
export const MALL_COURIERS = [
  'CJ대한통운',
  '한진택배',
  '롯데택배',
  '우체국택배',
  '로젠택배',
  '경동택배',
  'CU편의점택배',
  'GS편의점택배',
  '대신택배',
  '일양로지스',
  '천일택배',
  '직접배송',
] as const

export type MallCourier = (typeof MALL_COURIERS)[number]

export function isKnownMallCourier(name: string): name is MallCourier {
  return (MALL_COURIERS as readonly string[]).includes(name)
}

export function isDirectCourierName(courier: string): boolean {
  return /직접/.test(String(courier || ''))
}

/** 택배사 홈페이지 조회 URL. 직접배송은 null, 미지원은 검색. */
export function publicTrackingUrl(courier: string, invoice: string): string | null {
  const inv = String(invoice || '').replace(/\s+/g, '')
  if (!inv) return null
  const name = String(courier || '').trim()
  if (!name || isDirectCourierName(name)) return null
  if (/CJ|대한통운/i.test(name)) {
    return `https://www.cjlogistics.com/ko/tool/parcel/tracking?gnbInvcNo=${encodeURIComponent(inv)}`
  }
  if (/우체국/i.test(name)) {
    return `https://service.epost.go.kr/trace.RetrieveDomRigiTraceList.comm?sid1=${encodeURIComponent(inv)}`
  }
  if (/한진/i.test(name)) {
    return `https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillSch.do?mCode=MN038&wbl_num=${encodeURIComponent(inv)}`
  }
  if (/롯데/i.test(name)) {
    return `https://www.lotteglogis.com/open/tracking?invno=${encodeURIComponent(inv)}`
  }
  if (/로젠/i.test(name)) {
    return `https://www.ilogen.com/web/personal/trace/${encodeURIComponent(inv)}`
  }
  if (/경동/i.test(name)) {
    return `https://kdexp.com/service/delivery/my/tracking.do?barcode=${encodeURIComponent(inv)}`
  }
  if (/대신/i.test(name)) {
    return `https://www.ds3211.co.kr/tb/openweb/waybill_h.php?stype=11&pTdNo=${encodeURIComponent(inv)}`
  }
  if (/일양/i.test(name)) {
    return `https://www.ilyanglogis.com/functionality/tracking_view.asp?hawb_no=${encodeURIComponent(inv)}`
  }
  if (/GS|포스트박스/i.test(name)) {
    return `https://www.cvsnet.co.kr/invoice/tracking.do?invoice_no=${encodeURIComponent(inv)}`
  }
  if (/CU/i.test(name)) {
    return `https://www.cupost.co.kr/postbox/delivery/local_result.cupost?invoice_no=${encodeURIComponent(inv)}`
  }
  if (/천일/i.test(name)) {
    return `https://www.chunil.co.kr/HTrace/HTrace.jsp?transNo=${encodeURIComponent(inv)}`
  }
  return `https://www.google.com/search?q=${encodeURIComponent(`${name} ${inv} 배송조회`)}`
}
